<script setup lang="ts">
import { I18nKey } from '@/utils/typings';
import { computed } from 'vue';
import { getWorkStateIcon } from '@/views/jobOccurrences/utils/jobExecutionProgress';
import { WorkState } from '@/api/generator';
import Tooltip from '../Tooltip/Tooltip.vue';

const props = withDefaults(
  defineProps<{
    value?: WorkState;
    disabled?: boolean;
  }>(),
  {
    value: undefined,
    disabled: () => false,
  },
);

const iconProps = computed(
  () =>
    props.value && {
      ...getWorkStateIcon(props.value, true),
      ...(props.disabled ? { color: '#00000044' } : {}),
    },
);
</script>

<template>
  <Tooltip v-if="iconProps" position="top">
    <template #target="{ props: targetProps }">
      <v-icon size="large" v-bind="{ ...iconProps, ...targetProps }" />
    </template>

    <template #tooltip>
      {{ $t(`EvaluationStateEnum.${props.value}` as I18nKey) }}
    </template>
  </Tooltip>
</template>
